// Rotas App Routing
export enum RotasApp {
  HOME = 'home',
  TRANSMISSORA = 'transmissora',
  RECEPTORA = 'receptora',
  CALLBACK = 'callback',
  PAGTO_RECORRENTE = 'pagto-recorrente',
  TRANSFERENCIA_INTELIGENTE = 'transferencia-inteligente',
  PIX_AUTOMATICO = 'pix-automatico',
  INICIADORA_PIX_INTELIGENTE = 'iniciadora-pix-inteligente',
  DEPOSITO = 'deposito',
  HANDOFF = 'handoff',
  PORTABILIDADE_CREDITO = 'portabilidade-credito',
  GESTAO_VINCULOS = 'listagem'
}

// Módulo Home
export enum RotasHome {
  TERMOS = 'termos',
  FAQ = 'faq',
  COMPARTILHAMENTOS = 'compartilhamentos',
  COMPLEMENTARES = 'complementares',
  SUCESSO_CANCELAMENTO = 'sucesso-cancelamento',
  DADOS_DESCRICAO = 'dados-descricao',
  PAGAMENTOS = 'pagamentos',
  COMPLEMENTAR_PAGAMENTO = 'complementar-pagamento',
  TRAZER_RECURSOS = 'trazer-recursos',
  TUTORIAL = 'tutorial',
}

// Módulo Pagamento Recorrente
export enum RotasPagtoRecorrente {
  MEUS_PAGAMENTOS = 'meus-pagamentos',
  RESUMO_PAGAMENTO = 'resumo-pagamento',
  DETALHAR_PAGAMENTO = 'detalhar-pagamento',
  SUCESSO_CANCELAMENTO = 'sucesso-cancelamento',
  COMPROVANTE_PAGAMENTO = 'comprovante-pagamento',
}

// Módulo Transferencias Inteligentes
export enum RotasTransferenciaInteligente {
  MINHAS_TRANSFERENCIAS = 'minhas-transferencias',
  RESUMO_TRANSFERENCIA = 'resumo-transferencia',
  DETALHAR_TRANSFERENCIA = 'detalhar-transferencia',
  SUCESSO_CANCELAMENTO = 'sucesso-cancelamento',
  COMPROVANTE_TRANSFERENCIA = 'comprovante-transferencia',
}

// Módulo Receptora Simples
export enum RotasReceptoraSimples {
  LISTA_PARTICIPANTES = 'lista-participantes',
  REDIRECIONAMENTO = 'redirecionamento',
  TERMOS = 'termos',
  RESUMO = 'resumo',
}

// Módulo Pix Automático
export enum RotasPixAutomatico {
  RESUMO_PIX = 'resumo-pix',
  VISUALIZAR_PAGTOS_PIX = 'visualizar-pagtos-pix',
  DETALHE_PAGTO_PIX = 'detalhe-pagto-pix',
  ALTERAR_DEFINICOES = 'alterar-definicoes',
  SUCESSO_DEFINICOES = 'sucesso-definicoes',
  SUCESSO_CANCELAMENTO = 'sucesso-cancelamento-pix',
  SUCESSO_CANCELAMENTO_AUTORIZACAO = 'sucesso-cancelamento-autorizacao',
  COMPROVANTE = 'comprovante',
  COMPROVANTE_PAGAMENTO = 'comprovante-pagamento',
}

// Módulo Iniciadora Pix Inteligente
export enum RotasIniciadoraPixInteligente {
  RESUMO_CONSENTIMENTO = 'resumo-consentimento',
  ALTERAR_DADOS = 'alterar-dados',
  LISTA_PARTICIPANTES = 'lista-participantes',
  REDIRECIONAMENTO_PIX = 'redirecionamento-pix',
  VALOR_PIX = 'valor-pix',
  CONFIRMACAO_PAGAMENTO_PIX = 'confirmacao-pagamento-pix',
  CONFIRMACAO_CONSENTIMENTO_PIX = 'confirmacao-consentimento-pix',
}

// Módulo Portabilidade Crédito
export enum RotasPortabilidadeCredito {
  DETALHE_PROPOSTA = 'detalhe-proposta',
  SUCESSO_CANCELAMENTO = 'sucesso-cancelamento',
}


export enum RotasGestaoVinculos {
  DETALHE_INSTITUICAO = 'detalhe-instituicao',
  FILTRO_INSTITUICAO = 'detalhe-instituicao'
}